/**
 * @generated SignedSource<<09406d7477a9536f106d69a8c3fec386>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PricingDialog_org$data = {
  readonly id: string;
  readonly experiments: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "PricingDialog_org";
};
export type PricingDialog_org$key = {
  readonly " $data"?: PricingDialog_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"PricingDialog_org">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PricingDialog_org",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "experiments",
      "storageKey": null
    }
  ],
  "type": "Org",
  "abstractKey": null
};

(node as any).hash = "938af76c1046204c7bd4d3da3ac6ac5a";

export default node;
